import { jsx } from 'react/jsx-runtime';
import * as React from 'react';
import { forwardRef } from 'react';

var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function SvgStar(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.3997 10.4935L12.0001 6.21582L10.6004 10.4935L6.09517 10.4935L9.73999 13.1232L8.34319 17.3922L12.0001 14.7538L15.6569 17.3922L14.2601 13.1232L17.9049 10.4935H13.3997ZM9.87544 9.49352H6.09517C5.12476 9.49352 4.72311 10.7367 5.51007 11.3045L8.56236 13.5067L7.39277 17.0813C7.09173 18.0013 8.14321 18.7696 8.92829 18.2032L12.0001 15.9869L15.0718 18.2032C15.8569 18.7696 16.9084 18.0013 16.6073 17.0813L15.4377 13.5067L18.49 11.3045C19.277 10.7367 18.8753 9.49352 17.9049 9.49352H14.1247L12.9505 5.90485C12.6499 4.98614 11.3502 4.98614 11.0496 5.90485L9.87544 9.49352Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);

var StarOutline = forwardRef((props, ref) => jsx(ForwardRef, Object.assign({
  ref: ref
}, props)));

export { StarOutline as default };
